<div>
        <mat-dialog-content class="st-Dialog mat-dialog-content-padded"> 
          <div class="row">
            <div class="col-sm-12 padding-left-30">
                  <p class="xlarge"><strong>{{ 'NXI_PORTAL_COMPONENTS.SESSION_TIMEOUT_MESSAGE' | pershingTranslate }}</strong></p>
                  <div class="center padding-10 st-Time">
                    <span id="minutes" class="mat-raised-button mat-primary btn margin-right-5">{{minutesleft}}</span>{{ 'NXI_PORTAL_COMPONENTS.MINUTES' | pershingTranslate }}
                    <span id="seconds" class="mat-raised-button mat-primary margin-left-20 margin-right-5">{{secondsLeft}}</span>{{ 'NXI_PORTAL_COMPONENTS.SECONDS' | pershingTranslate }}</div>
                  <p>{{ 'NXI_PORTAL_COMPONENTS.SESSION_TIMEOUT_SAFETY' | pershingTranslate }}</p>
                      <p>{{ 'NXI_PORTAL_COMPONENTS.SESSION_TIMEOUT_CONTINUE_WORKING' | pershingTranslate }}</p>
            </div>
          </div>
            <div class="action-buttons center">
              <button mat-raised-button color="primary" type="button" (click)="continue();"> {{ 'NXI_PORTAL_COMPONENTS.CONTINUE' | pershingTranslate }} </button>
            </div>
        </mat-dialog-content> 
</div>